var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreePhthalate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 53,
    viewBox: "0 0 215 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1242_23396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.649 0.0692752C207.341 5.00995 199.997 0.622078 194.024 3.62795C189.526 5.90826 188.121 11.6436 187.699 15.1677C187.699 15.1677 184.326 15.9624 180.461 15.8242C179.161 15.7551 179.196 18.45 180.25 18.5536C193.848 19.5901 207.832 6.56471 207.832 6.56471C207.832 6.56471 202.316 18.0008 189.316 20.8685C191.283 22.1123 196.659 25.3255 203.194 21.2831C212.014 15.7896 216.371 -1.03633 214.649 0.103825V0.0692752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.4252V0.829346H7.27325C9.45171 0.829346 11.2085 1.4167 12.5086 2.59141C13.8086 3.76611 14.4762 5.32087 14.4762 7.29023C14.4762 8.60314 14.1249 9.77785 13.4573 10.7798C12.7897 11.7818 11.8761 12.5419 10.7166 12.991C9.55712 13.4402 7.9057 13.682 5.72724 13.682H3.30283V23.4597H0L0 23.4252ZM6.71106 3.73156H3.30283V10.7798H6.88675C8.22193 10.7798 9.24089 10.4689 9.97875 9.84695C10.7166 9.22505 11.068 8.32674 11.068 7.18658C11.068 4.87172 9.62739 3.69701 6.71106 3.69701V3.73156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5202 0.86377H36.823V23.4251H33.5202V13.6128H20.6251V23.4251H17.3223V0.86377H20.6251V10.6069H33.5202V0.86377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.915 0.829346H59.0996V3.69701H51.0884V23.4252H47.7856V3.73156H39.915V0.829346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3542 0.86377H81.657V23.4251H78.3542V13.6128H65.4591V23.4251H62.1562V0.86377H65.4591V10.6069H78.3542V0.86377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0247 0.725586H96.3437L106.639 23.4251H103.266L100.209 16.7223H90.4057L87.5245 23.4251H84.1514L94.0247 0.725586ZM98.8735 13.8892L95.1842 5.70082L91.7408 13.8892H98.8735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.134 0.86377H112.437V20.4883H122.767V23.4251H109.134V0.86377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.956 0.725586H135.275L145.57 23.4251H142.197L139.14 16.7223H129.337L126.456 23.4251H123.083L132.956 0.725586ZM137.805 13.8892L134.116 5.70082L130.672 13.8892H137.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.759 0.829346H161.943V3.69701H153.932V23.4252H150.629V3.73156H142.759V0.829346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.035 0.86377H178.036V3.73144H168.303V10.6069H177.684V13.5091H168.303V20.5228H178.352V23.3905H165.035V0.86377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.465 30.4386H157.692V33.3063H148.733V39.5944H157.692V42.4621H148.733V52.9654H145.43V30.4041L145.465 30.4386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.663 53V30.4387H167.425C169.744 30.4387 171.607 30.9915 172.942 32.1317C174.312 33.2718 174.98 34.792 174.98 36.7269C174.98 38.0398 174.628 39.1799 173.961 40.1473C173.293 41.1147 172.345 41.8057 171.08 42.2894C171.818 42.7731 172.52 43.395 173.223 44.2242C173.926 45.0534 174.91 46.47 176.174 48.5085C176.983 49.7868 177.615 50.7542 178.107 51.4107L179.337 53.0345H175.437L174.453 51.5489C174.453 51.5489 174.347 51.4107 174.242 51.2725L173.609 50.3742L172.591 48.7158L171.501 46.9537C170.834 46.0209 170.201 45.2953 169.639 44.7425C169.077 44.1897 168.55 43.8096 168.093 43.5678C167.636 43.3259 166.863 43.2223 165.809 43.2223H164.966V53.0345H161.663V53ZM165.95 33.1682H164.966V40.2855H166.231C167.882 40.2855 169.042 40.1473 169.639 39.8709C170.272 39.5945 170.728 39.1799 171.08 38.5926C171.431 38.0398 171.607 37.3833 171.607 36.6578C171.607 35.9322 171.431 35.3103 171.045 34.7229C170.658 34.1356 170.131 33.7555 169.428 33.5137C168.726 33.2718 167.566 33.1682 165.985 33.1682H165.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.254 30.4387H195.254V33.3064H185.522V40.1819H194.903V43.0841H185.522V50.0978H195.571V52.9654H182.254V30.4387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.47 30.4387H212.47V33.3064H202.737V40.1819H212.119V43.0841H202.737V50.0978H212.786V52.9654H199.47V30.4387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1242_23396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePhthalate);
export default __webpack_public_path__ + "static/media/free-phthalate.0b545fb6684afc9d6042ecefc8a33edb.svg";
export { ForwardRef as ReactComponent };